import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_LOCATION_DATA_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),
	},
	{
		intro: '',
		train: '',
		bus: '',
		drive: '',
		park: '',
		hotel: '',
		airplane: '',
	},
);



// WEBPACK FOOTER //
// ./src/reducers/location.js